// Cosima PDP — small enhancements that have no native Horizon equivalent.
// Everything else (drawer, accordion, tabs) is CSS/native — this file only
// exists for the one interaction that genuinely needs JS: copying the
// product URL from the icon row's "share" button.
(function () {
  'use strict';

  document.addEventListener('click', function (event) {
    var btn = event.target.closest('[data-copy-link]');
    if (!btn) return;

    var url = window.location.href;
    var done = function () {
      btn.setAttribute('data-copied', 'true');
      setTimeout(function () { btn.removeAttribute('data-copied'); }, 2000);
    };

    if (navigator.clipboard && window.isSecureContext) {
      navigator.clipboard.writeText(url).then(done).catch(function () {});
    } else {
      var input = document.createElement('input');
      input.value = url;
      input.style.position = 'fixed';
      input.style.opacity = '0';
      document.body.appendChild(input);
      input.select();
      try { document.execCommand('copy'); done(); } catch (e) {}
      document.body.removeChild(input);
    }
  });
})();
